// extracted by mini-css-extract-plugin
export var buttonContainer = "_9k-1";
export var fontSizeSelect = "_9k-3";
export var formatSelect = "_9k-2";
export var formats = "_9k-4";
export var hidden = "_9k-5";
export var icon = "_9k-6";
export var select = "_9k-0";